import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {InfoPanel} from "../../atoms/InfoPanel";
import {ListMainHeader} from "./ListMainHeader";

interface IProps {
    className?: string;
    useHeader?: boolean;
    heading?: string;
    subHeading?: string;
    additionalContent?: React.ReactNode;
}

export const EmptyList: React.FC<IProps> = (props) => {
    return (
        <>
            {props.useHeader && <ListMainHeader />}
            <InfoPanel
                className={props.className}
                icon={BrandSearchIcon}
                heading={props.heading || "Nie znaleziono ofert spełniających wybrane kryteria"}
                headingAs="p"
                subHeading={
                    props.subHeading || (
                        <>
                            Jeśli chcesz wyczyścić wyniki wyszukiwania, ponownie przejdź do{" "}
                            <Link className={link} href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                                wyszukiwarki ofert
                            </Link>
                            .
                        </>
                    )
                }
                additionalContent={props.additionalContent}
                subHeadingAs="p"
            />
        </>
    );
};

const link = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)"
});
import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {InfoPanel} from "../../atoms/InfoPanel";
import {ListMainHeader} from "./ListMainHeader";

interface IProps {
    className?: string;
    useHeader?: boolean;
    heading?: string;
    subHeading?: string;
    additionalContent?: React.ReactNode;
}

export const EmptyList: React.FC<IProps> = (props) => {
    return (
        <>
            {props.useHeader && <ListMainHeader />}
            <InfoPanel
                className={props.className}
                icon={BrandSearchIcon}
                heading={props.heading || "Nie znaleziono ofert spełniających wybrane kryteria"}
                headingAs="p"
                subHeading={
                    props.subHeading || (
                        <>
                            Jeśli chcesz wyczyścić wyniki wyszukiwania, ponownie przejdź do{" "}
                            <Link className={link} href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                                wyszukiwarki ofert
                            </Link>
                            .
                        </>
                    )
                }
                additionalContent={props.additionalContent}
                subHeadingAs="p"
            />
        </>
    );
};

const link = css({
    textDecoration: "underline",
    color: "var(--colors-gray-700)"
});
